import { Link } from "react-router-dom";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";

const NotFoundPage = () => {
  return (
    <>
      <SiteTitle title="صفحه مورد نظر یافت نشد" />

      <div className="text-center my-5">
        <img
          src="/assets/images/404.png"
          alt="صفحه مورد نظر یافت نشد"
          className="img-fluid"
        />
        <h3>صفحه مورد نظر یافت نشد</h3>
        <Link to="/" className="kf-btn">
          <span>صفحه اصلی</span>
        </Link>
      </div>
    </>
  );
};

export default NotFoundPage;
